<template>
<div v-bind="$attrs">
   <v-toolbar dense flat color="transparent">
   <v-tabs v-model="tab" fixed-tabs>
    <v-tab @click="resetMe">Postcode</v-tab>
    <v-tab @click="resetMe">Adres</v-tab>
    <v-tab v-if="address" style="width:30px"><v-icon>location_on</v-icon></v-tab>
  </v-tabs>
  </v-toolbar>
  <v-divider></v-divider>
  <v-card flat>
  <v-list class="py-0" :class="{'pl-7 mr-15' : largeScreen}">
    <template v-if="!address">
      <v-subheader v-if="hint" v-text="hint"></v-subheader>
      <v-subheader v-else-if="tab==0">Voer je postcode en huisnummer in</v-subheader>
      <v-subheader v-else-if="tab==1">Voer je adres in</v-subheader>
      <v-subheader v-else>Dit adres gebruiken?</v-subheader>
    </template>
    <v-list-item class="dense pr-2 mb-3" v-if="tab==0" v-show="!address">
              
              <v-list-item-content>
                <v-list-item-title class="d-flex" style="max-width:250px">  
                <character-input v-model="zipcode"
                :mask="['*','*','*','*','#','#']"
                :deviders="[,,,'-',]"
                :autofocus="!zipcode && autofocus"
                :size="6" @finish="getAdres"></character-input>

            <!--otp-input ref="zipnumbers" :length="4" :autofocus="!zipnumbers && autofocus"
               v-model="zipnumbers" color="primary" @finish="setNumbers" :dark="dark"
              ></otp-input>
              <div class="text-h4 grey--text mx-1">-</div>
             <v-otp-input hide-spin-buttons
                v-model="zipnumbers"  class="phone mr-5"
                ref="zipnumbers"
                @finish="$refs.zipchars.focus()"
                type="number"
                :autofocus="autofocus && platform!=='ios'"
                length="4"
              ></v-otp-input>
               <otp-input ref="zipchars" :length="2" :autofocus="zipnumbers && zipnumbers.length==4 && !zipchars"
               v-model="zipchars" color="primary" @finish="setChars"  :dark="dark"
               type="text"
              ></otp-input-->
                      </v-list-item-title>
            
            
                <!--slot name="message" v-else></slot-->
              </v-list-item-content>
                <v-list-item-action style="width:70px">
                <v-text-field
                  ref="number"
                  v-model="number"
                   :background-color="color"
                  flat outlined
                  class="pa-0 ma-0 addressnumber text-h6 font-weight-normal"
                  dense hide-details
                  :rules="[$config.rules.required]"
                  placeholder="NR"
                  @focus="$event.target.select()"
                  solo @keyup="checkTimed"
                  
                >
                </v-text-field> <!--@keyup="checkTimed"
                  @keyup.enter.native="getAddress"-->
                  
              </v-list-item-action>

                  
      </v-list-item>
      <v-list-item v-else-if="tab==1" class="mb-3">
        <v-list-item-content>  
        <address-select-name outlined
                 class="ma-0 pa-0" autofocus
                   style="width:100%;" @select="selectMe"></address-select-name> 
        </v-list-item-content>
      </v-list-item>
      <template v-if="!autoSelect && address || loading || message">
        
       <v-list-item class="pt-3 px-2">
                          <v-list-item-action class="mr-2">
                                <v-btn icon @click="resetMe"><v-icon>close</v-icon></v-btn>
                          </v-list-item-action>
                         <v-list-item-content>
                           <span v-if="!address" class="error--text font-weight-bold">{{message}}</span>
                            
                          <v-list-item-title v-else class="primary--text mb-1">{{address.name}}</v-list-item-title>
                       </v-list-item-content>
                       <v-list-item-action style="width:70px" v-if="address">
                            <v-text-field
                              ref="number"
                               type="number" hide-spin-buttons
                              v-model="address.number"
                              :background-color="color"
                              flat outlined
                              class="pa-0 ma-0 addressnumber text-h6 font-weight-normal"
                              dense hide-details
                              :rules="[$config.rules.required]"
                              placeholder="NR"
                              @focus="$event.target.select()"
                              solo @keyup="checkTimed"
                              
                            >
                            </v-text-field> <!--@keyup="checkTimed"
                              @keyup.enter.native="getAddress"-->
                              
                          </v-list-item-action>
                       
                 </v-list-item>
            </template>
            
            
         <v-divider></v-divider>
              </v-list>
  </v-card>
  <v-card-actions class="pr-4" v-if="address && !loading">
                                    <v-btn v-if="tab==2" text :loading="loading" :disabled="!isValid" @click="goToSearch">Nee</v-btn>
                                    
                    <v-spacer></v-spacer>                        
                              <v-btn v-if="tab==2" class="success" :loading="loading" :disabled="!isValid" depressed @click="selectMe(address)">Ja</v-btn>
                             <v-btn v-else class="success" :loading="loading" :disabled="!isValid" depressed @click="selectMe(address)">selecteren</v-btn>
            </v-card-actions>
            <v-btn v-else text @click="cancel" color="grey" class="mt-3 float-right" small>
                Annuleren
              </v-btn>
              
</div>
</template>

<script>
import locationService from '@/modules/locationService'
import OtpInput from './otp/OtpInput.vue'
import AddressSelectName from "./AddressSelectName.vue";
import CharacterInput from './CharacterInput.vue';
export default {
  mixins: [locationService],
  components: {
    OtpInput, AddressSelectName,
    CharacterInput
  },
  props: {
    value: {
      type: Object,
      default: function () {
        return null
      },
    },
    color: {
      type: String,
      default: function () {
        return null
      },
    },
    hint: {
      type: String,
      default: function () {
        return null
      },
    },
    autofocus: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    dark: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    manual: {
      type: Boolean,
      default: function () {
        return true
      },
    },
    dense: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    showCurrent: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    autoSelect: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    
  },
   data: () => ({
     tab:0,
      valid: true,
     loading: false,
     timer: null,
     message:null,
     zipCodeSearch: true,
     address:null,
     zipcode: null,
     zipnumbers: null,
     zipchars: null,
      number: null,
      search: null,
      hasfocus: false,
      listings: []
  }),
  computed: {
    addresslist(){
      let list = this.listings
      //if (this.allowCurrent) list.push(this.current)
      return list
    },
    addressModel:{
      get(){
        return this.value
      },
      set(value){
        this.$emit('input', value)
      }
    },
    zipcodes:{
      get(){
        if (!this.zipchars) return this.zipnumbers
        return [this.zipnumbers, this.zipchars].join(' ').toUpperCase()
      },
      set(value){
        if (!value) return false
        this.zipnumbers = value.substring(0,4)
        this.zipchars = value.replace(this.zipnumbers,'').trim()
      }
    },
    name (){
      if (!this.address) return null
      return [this.address.street,this.address.number ,this.address.addition,",",this.address.city].filter(a=>a!=undefined).join(' ').replace(' , ',', ')
    },
    isValid(){
      if (!this.address) return false
      if (this.address && this.address.zipcode && this.$config.rules.zipcode(this.address.zipcode) && this.address.number) return true
      return false
    },
    pageHeight() {
      return document.body.scrollHeight;
    },
  },
  async mounted(){
    if (this.value) {
      this.address = this.clone(this.value)
      if (this.address.current) this.tab=2
    }
    this.hasfocus = false
      if (!this.address || !this.address.zipcode) {
        this.address = null
        this.$nextTick(()=>{
         //this.$set(this.address,'zipcode',this.baseZip)
          if (this.$refs.zipinput) this.$refs.zipinput.setFocus(0)
       })
      }
      
      //let res = await this.getLocation()
      //return {_key: 'current', name: 'Mijn huidige locatie gebruiken'}
  },
  watch: {
    value(value){
      if (value) {
        this.address = this.clone(value)
        if (this.address.current) this.tab=2
      }
    },
    address(value){
      this.valid = !this.$refs.form || this.$refs.form.validate()
      if (this.valid && this.autoSelect) this.selectMe(value)
      if (!value || !this.value || value.name!=this.value.name) this.$emit('input', value)
      this.$vuetify.goTo(this.pageHeight);
    },
     name(value){
      if (this.address) this.address.name = value
    },
    /*value(value){
      if (value) this.address = this.clone(value)
    },*/
  },
  methods: {
    setNumbers(numbers){
      this.zipnumbers=numbers
      try{
        this.$nextTick(()=>{
            this.$refs.zipchars.$children[0].$refs.input.focus()
            console.log('ficuss',this.$refs.zipchars.$children[0].$refs.input)
        })
      }catch(e){
        console.log('error',e)
      }
    },
    setChars(chars){
      this.zipchars=chars
      try{
        this.$nextTick(()=>this.$refs.number.focus())
      }catch(e){
        console.log('error',e)
      }
    },
    checkTimed() {
      this.loading = true
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => this.getAdres(), 500)
    },
    async getAdres(){
      this.message = ""
        //if (!this.number) return this.loading = false
        this.listings = await this.getAddressSearch({zipcode: this.zipcode, number:this.number})
        this.address = this.listings[0]
        this.loading = false
        if (!this.address) return this.message = "Geen geldig adres gevonden"
        if (this.autoSelect) {
          this.$emit('select', this.address)
          this.resetMe()
        }
        
    },

     getAddressData(address,place){
       if (!address) return false
       if (!address.postal_code, place){
        let zip = place.address_components.filter(ac=>ac.types && ac.types.includes('postal_code'))[0]
        if (zip) address.postal_code = zip.long_name
      }
      this.address = 
      {
        "zipcode": address.postal_code,
        "coordinate": [
          address.latitude,
          address.longitude
        ],
        "current": false,
        "county": address.country,
        "city": address.locality,
        "name": address.name,
        "street": address.route || address.name,
        "number": address.street_number,
        "addition": address.street_addition,
        "region": address.administrative_area_level_1,
        "token": address.place_id,
      }
      this.address.name = this.name
      //this.selectMe(this.address)
      //this.$emit('input', this.search)
    },
    goToSearch(){
      this.tab=1
      this.resetMe()
    },
    resetMe(){
      
      this.zipnumbers = null
      this.zipchars = null
      this.zipcode = null
      this.number = null
      this.address = null
      this.message = null
    },
    cancel(){
      this.resetMe()
      this.$emit('cancel')
    },
    focusMe(){
      this.hasfocus = true
      if (this.$refs.addressselect) this.$vuetify.goTo(this.$refs.addressselect, {duration: 500, offset: 120})
      this.$emit('focus')
    },
    /*onBlur(){
      this.hasfocus = false
      if (!this.address || !this.search || this.search.length < 3) this.$emit('cancel')
    },*/
    /*checkSearch(address){
     //if (address && address._key == 'current') return this.getCurrentLocation()
        this.selectMe(address)
    },*/
    async getCurrentLocation(){
        this.address = await this.getLocation()
        //return this.selectMe(addAddress)
    },
    /*Me(){
      this.$emit('input', this.search)
    },*/
    setAddress(address){
        this.address=address

    },
    selectMe(address){
      if (address) this.address=address
      if (!this.isValid) return false
      this.$emit('select', this.address)
      this.cancel()
    },
    updateError() {
      console.log('error');
    }
  }
}
function setCaretPosition(elemId, caretPos) {
    var elem = document.getElementById(elemId);
     if(elem != null) {
        if(elem.createTextRange) {
            var range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
        }
        else {
            if(elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            }
            else
                elem.focus();
        }
    }
}
</script>
<style>
.pac-item {
  padding: 8px 4px;
}
.pac-item, .pac-item-query, .pac-matched{
  font-size:1em;
}
.addressnumber input {
  max-height:50px!important;
  height: 42px;
}
</style>